/**
 * Returns a same-origin relative URL (path + query + hash), or the fallback when the
 * url is empty, malformed or points to a different origin.
 */
export const getSafeRedirectUrl = (url?: string | null, fallback = "/") => {
    if (!url) {
        return fallback;
    }

    try {
        const parsedUrl = new URL(url, window.location.origin);

        if (parsedUrl.origin !== window.location.origin) {
            return fallback;
        }

        return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    } catch {
        return fallback;
    }
};

/**
 * Returns the absolute URL when it is http(s) and, if allowedHosts is supplied, its host equals
 * or is a subdomain of one of the allowed hosts. Returns undefined otherwise.
 */
export const getSafeExternalUrl = (url?: string | URL | null, allowedHosts?: string[]) => {
    if (!url) {
        return undefined;
    }

    try {
        const parsedUrl = new URL(url.toString(), window.location.origin);

        if (parsedUrl.protocol !== "https:" && parsedUrl.protocol !== "http:") {
            return undefined;
        }

        if (allowedHosts) {
            const hostname = parsedUrl.hostname.toLowerCase();
            const isAllowed = allowedHosts.some(host => {
                const allowedHost = host.toLowerCase();
                return hostname === allowedHost || hostname.endsWith(`.${allowedHost}`);
            });

            if (!isAllowed) {
                return undefined;
            }
        }

        return parsedUrl.href;
    } catch {
        return undefined;
    }
};
